module.exports = __webpack_public_path__ + "static/media/GTL.0ee2f18f.png";